import floatLabels from '../globals/forms';
import {setVarsOnResize, setVars} from '../globals/height';
import preventOverflow from '../globals/prevent-overflow';
import resizeListener from '../globals/resize';
import scrollListener from '../globals/scroll';
import isTouch from '../util/touch';
import {ariaToggle} from '../globals/legacy';

resizeListener();
scrollListener();
isTouch();
setVars();

window.addEventListener('load', () => {
  setVarsOnResize();
  floatLabels(document);
  preventOverflow(document);
  ariaToggle(document);
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  floatLabels(container);
  preventOverflow(container);
  ariaToggle(document);

  document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
});

document.addEventListener('shopify:section:reorder', () => {
  document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
});

document.addEventListener('shopify:section:unload', () => {
  // When you hide/disable a section, the unload event is fired before the section is actually removed from the DOM
  // We need a little delay before checking for transparent header to make sure it's already removed from the DOM
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent('theme:header:update', {bubbles: true}));
  }, 200);
});
